import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fae01ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "law-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "联系我们", -1))
const _hoisted_3 = { class: "law-footer-bottom-left-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全面合作：孟先生，13671346785（微信v576894）", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "投诉管理：孔先生，13671344225（微信ify12348）", -1))
const _hoisted_6 = { class: "law-footer-bottom-left-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "2744627070@qq.com ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "law-footer-bottom-left-text" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"vertical-align":"middle"} }, [
    /*#__PURE__*/_createElementVNode("img", { src: "https://cdn.fy12348.cn/icons/icon-beian-gov.png" }),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank",
        style: {"color":"#ffffff","text-decoration":"none","margin-left":"5px"}
      }, "京ICP备2022013200号-1")
    ])
  ])
], -1))
const _hoisted_9 = { class: "law-footer-bottom-center-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "打开简介"),
  /*#__PURE__*/_createElementVNode("span", { style: {"border-left":"1px solid #a9baba","border-right":"1px solid #a9baba","padding":"0 2px","margin":"0 4px"} }, " 新闻中心 "),
  /*#__PURE__*/_createElementVNode("span", null, "加入我们")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "七大解决方案", -1))

import {
  Iphone,
  Message,
  Location,
  ChatDotRound,
} from "@element-plus/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'footer',
  setup(__props) {

const blogrollArr = [
  "中国电子商会",
  "江西商会",
  "IOS开发",
  "WEB开发",
  "APP开发",
  "公司手机",
  "IOS开发",
  "WEB开发",
];
const solution = [
  "全面法律风险体检",
  "签约内部法律培训",
  "企业法律咨询",
  "起草/审查合同",
  "专项法律意见书",
  "律师函/商务沟通函",
  "诉讼及仲裁",
];

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.ismx==true?'law-footer-bottom':'law-footer-bottom law-footer-bottom2'])
    }, [
      _createVNode(_component_el_row, { align: "middle" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            sm: 8,
            xs: 24,
            class: _normalizeClass([_ctx.ismx==true?'law-footer-bottom-left':''])
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_icon, { size: 13 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Iphone))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" CONTOCT PHONE ")
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_icon, { size: 13 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Message))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" CONTOCT E-MAIL ")
                ])
              ]),
              _hoisted_8
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_col, {
            sm: 8,
            xs: 24,
            class: _normalizeClass([_ctx.ismx==true?'law-footer-bottom-center':''])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_image, {
                style: {"width":"80px","height":"80px"},
                src: "https://cdn.fy12348.cn/logo/ify-wxminiqr.jpg",
                fit: "fill"
              }),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_icon, { size: 13 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChatDotRound))
                  ]),
                  _: 1
                }),
                _createTextVNode(" 关注微信小程序"),
                _hoisted_10,
                _createTextVNode("线上实时进行相关咨询 ")
              ]),
              _hoisted_11
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_col, {
            sm: 8,
            xs: 24,
            class: _normalizeClass([_ctx.ismx==true?'law-footer-bottom-right':''])
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(solution, (item) => {
                return _createElementVNode("div", { key: item }, _toDisplayString(item), 1)
              }), 64))
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ], 2)
  ]))
}
}

})